var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DatePicker, Descriptions, Form, Input, Upload, message } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
const DirectRenewalForm = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const [certIssueDate, setCertIssueDate] = useState('');
    const [certExpiredDate, setCertExpiredDate] = useState('');
    const customFormat = (value) => `${value.format('DD-MM-YYYY')}`;
    const onChangeIssueDate = (date, dateString) => {
        if (date) {
            setCertIssueDate(date.add(1, 'day').format('DD-MM-YYYY'));
        }
        else {
            setCertIssueDate('');
        }
    };
    const onChangeExpDate = (date, dateString) => {
        if (date) {
            setCertExpiredDate(date.subtract(1, 'day').format('DD-MM-YYYY'));
        }
        else {
            setCertExpiredDate('');
        }
    };
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
    const customRequest = (_a) => __awaiter(void 0, [_a], void 0, function* ({ file, onSuccess, onError }) {
        const formData = new FormData();
        formData.append('file', file);
        try {
            // Simulate a successful response
            setTimeout(() => {
                if (onSuccess) {
                    onSuccess({ status: 'success' });
                }
            }, 100);
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
            message.error('Failed to upload file.');
        }
    });
    const onDownload = (file) => {
        // Example: Trigger a download for a file located at file.url
        if (file.url) {
            const a = document.createElement('a');
            a.href = file.url;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        else if (file.originFileObj) {
            // If the file is local (not yet uploaded), read it as a Blob
            const reader = new FileReader();
            reader.readAsArrayBuffer(file.originFileObj);
            reader.onload = () => {
                const blob = new Blob([reader.result]);
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = file.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(a.href);
            };
        }
    };
    const handleFileChange = (fileList) => {
        const { status } = fileList.file;
        if (status !== 'uploading') {
            fileList.status = 'done';
            message.success(`${fileList.file.name} ${fileList.file.status} file uploaded successfully.`);
        }
    };
    const styleLabel = {
        padding: '12px 12px',
        fontWeight: '600',
        marginBottom: '10px !important'
    };
    const style = { padding: '12px 12px', marginBottom: '20px !important' };
    const borderedItems = [
        {
            key: '1',
            label: 'Product Name:',
            children: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.strProductName),
        },
        {
            key: '2',
            label: 'Product Model:',
            children: ((_b = props.data) === null || _b === void 0 ? void 0 : _b.strSeriesModel),
        },
        {
            key: '3',
            label: 'Brand/OEM:',
            children: ((_d = (_c = props.data) === null || _c === void 0 ? void 0 : _c.objBrandName) === null || _d === void 0 ? void 0 : _d.strLongDesc),
        },
        {
            key: '4',
            label: 'Country/Territory:',
            children: ((_f = (_e = props.data) === null || _e === void 0 ? void 0 : _e.objLuCountry) === null || _f === void 0 ? void 0 : _f.strLongDesc),
        },
        {
            key: '5',
            label: 'Service Type:',
            children: ((_j = (_h = (_g = props.data) === null || _g === void 0 ? void 0 : _g.objTblService) === null || _h === void 0 ? void 0 : _h.objLuServiceCode) === null || _j === void 0 ? void 0 : _j.strLongDesc),
        },
        {
            key: '6',
            label: 'Product Sub Segment:',
            children: ((_m = (_l = (_k = props.data) === null || _k === void 0 ? void 0 : _k.objTblService) === null || _l === void 0 ? void 0 : _l.objLuProductMainType) === null || _m === void 0 ? void 0 : _m.strLongDesc),
        },
        {
            key: '7',
            label: 'Technology',
            children: ((_q = (_p = (_o = props.data) === null || _o === void 0 ? void 0 : _o.objTblService) === null || _p === void 0 ? void 0 : _p.objLuTechnologyType) === null || _q === void 0 ? void 0 : _q.strLongDesc),
        },
        {
            key: '8',
            label: 'Certificate Id:',
            children: _jsx(_Fragment, { children: _jsx(Form.Item, { name: 'strCertId', rules: [
                        {
                            required: true,
                            message: 'Certificate Id is Required'
                        }
                    ], children: _jsx(Input, { style: { width: 150 }, placeholder: "Certificate Id" }) }) }),
        },
        {
            key: '9',
            label: 'Certificate Issue Date:',
            children: _jsx(_Fragment, { children: _jsx(Form.Item, { name: 'dtCertIssueDate', rules: [
                        {
                            required: true,
                            message: 'Certificate Issue Date'
                        }
                    ], children: _jsx(DatePicker, { style: { width: 150 }, format: customFormat, onChange: onChangeIssueDate, multiple: false, maxDate: dayjs(certExpiredDate, 'DD-MM-YYYY') }) }) }),
        },
        {
            key: '10',
            label: 'Certificate Expiration Date:',
            children: _jsx(_Fragment, { children: _jsx(Form.Item, { name: 'dtCertExpirationDate', children: _jsx(DatePicker, { style: { width: 150 }, format: customFormat, multiple: false, onChange: onChangeExpDate, minDate: dayjs(certIssueDate, 'DD-MM-YYYY') }) }) }),
        },
        {
            key: '11',
            label: 'Certificate Document:',
            children: _jsx(_Fragment, { children: _jsx(Form.Item, { name: "certUpload", valuePropName: "fileList", getValueFromEvent: normFile, rules: [
                        {
                            required: true,
                            message: 'Certificate is Required'
                        }
                    ], children: _jsxs(Upload.Dragger, { name: "files", accept: 'application/pdf,application/x-zip-compressed', maxCount: 1, onChange: handleFileChange, customRequest: customRequest, showUploadList: { showDownloadIcon: true }, onDownload: onDownload, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(InboxOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: "Click or drag file to this area to upload" }), _jsx("p", { className: "ant-upload-hint", children: "Support for a single upload." })] }) }) }),
        },
    ];
    return (_jsx(_Fragment, { children: _jsx(Descriptions, { title: "Renewal Certificate Information", bordered: true, labelStyle: { fontWeight: 'bold' }, column: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 3 }, size: 'default', items: borderedItems }) }));
};
export default DirectRenewalForm;
